import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import Modalities from "../components/Modalities";
import PlatformFeatures from "../components/PlatformFeatures";
import ClinicalCapabilities from "../components/ClinicalCapabilities";
import Oncology from "../components/Oncology";
import ScanDemo from "../components/ScanDemo";
import Pricing from "../components/Pricing";
import CTASection from "../components/CTASection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import ChatWidget from "../components/ChatWidget";

export default function Landing() {
  return (
    <div className="bg-ink min-h-screen" data-testid="landing-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Modalities />
      <PlatformFeatures />
      <ClinicalCapabilities />
      <Oncology />
      <ScanDemo />
      <Pricing />
      <CTASection />
      <ContactSection />
      <Footer />
      <ChatWidget />
    </div>
  );
}
